import { Heading } from '../Heading';
import { Paragraph } from '../Paragraph';
import classes from './NotReady.module.css';
import { Button } from '../Button';
import { useNavigate } from 'react-router-dom';
import { Routes } from '../../enums/Routes.ts';

type NotReadyProps = {
  title: string;
  description: string;
  showNavigateButton?: boolean;
};
export const NotReady = ({
  showNavigateButton,
  title,
  description,
}: NotReadyProps) => {
  const navigateTo = useNavigate();
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Heading as="h1" className={classes.spacing}>
          {title}
        </Heading>
        <Paragraph as="p" size="lg" className={classes.spacing}>
          {description}
        </Paragraph>
        {showNavigateButton && (
          <Button
            variant="primary"
            className={classes.spacing}
            onClick={() => navigateTo(Routes.Dashboard)}
          >
            Tilbake til oversikt
          </Button>
        )}
      </div>
      <div>
        <img
          src="/trustpulse.svg"
          alt=""
          aria-hidden
          className={classes.image}
        />
      </div>
    </div>
  );
};
